import { createContext } from "react";
import { User } from "@domain/Auth";
//set initial value of user to null (pre-login)
export const UserContext = createContext<User | undefined>(undefined);
